module.exports = __webpack_public_path__ + "img/sy.58edb46c.png";